/**
 * Écrire une adresse d'annuaire sur une ligne, sans répéter la ville.
 *
 * L'API « Recherche d'entreprises » rend une `adresse` qui contient DÉJÀ le code
 * postal et la commune. Y recoller « 75002 PARIS » donnait « 5 RUE DE HANOVRE 75002
 * PARIS · 75002 PARIS ». Les deux champs sont conservés en base parce qu'ils servent
 * séparément (filtrer par ville, par département) ; c'est l'affichage qui doit
 * choisir.
 */
export function formatAddress(company: {
	address?: string | null;
	postalCode?: string | null;
	city?: string | null;
}): string {
	const address = company.address?.trim() ?? "";
	const town = [company.postalCode, company.city].filter(Boolean).join(" ");
	if (!address) return town;
	if (!town || address.includes(town)) return address;
	return `${address}, ${town}`;
}
